/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { __decorate } from "tslib";
import { CustomElement, attachShadowTemplate } from '@tylertech/forge-core';
import { BaseComponent } from '../../core/base/base-component';
import { VIEW_CONSTANTS } from './view-constants';
const template = '<template><slot></slot></template>';
const styles = ':host{display:block}:host([hidden]){display:none}';
/**
 * The web component class behind the `<forge-view>` custom element.
 *
 * @tag forge-view
 */
let ViewComponent = class ViewComponent extends BaseComponent {
    constructor() {
        super();
        attachShadowTemplate(this, template, styles);
    }
};
ViewComponent = __decorate([
    CustomElement({
        name: VIEW_CONSTANTS.elementName
    })
], ViewComponent);
export { ViewComponent };
